import Utils from "../../../../../Utils";
import * as toastr from "toastr";

export default function getCellCustomEditor() {

    function AgSelect() {
    }

    AgSelect.prototype.init = function (params) {
        this.params = params;
        const rowData = [];
        params.api.forEachNode(node => rowData.push(node.data));
        this.defaultValue = {...params.value};
        AgSelect.prototype.cellEditorparams = params.data.cellEditorParams || {};

        if (this.params.data.isNew) {
            let attributesGroup = Utils.$('<optgroup label="Attributes" />');
            let relationshipGroup = Utils.$('<optgroup label="Relationships" />');
            let optionsArr = [];
            let tagOption = null;

            params.column.userProvidedColDef.options.attr.forEach((item) => {
                let data = rowData.find( function( row ) {
                    return row.rowObj.id === item.id;
                });
                if (!data) {
                    let option = new Option(item.name, JSON.stringify({id: item.id, column: item.name, type: 'attribute', attr: item}));
                    optionsArr.push(option);
                    attributesGroup.append(option);
                }
            });

            params.column.userProvidedColDef.options.relationshipList.forEach((item) => {
                let data = rowData.find( function( row ) {
                    return row.rowObj.id === item.id;
                });
                if (!data) {
                    let option = new Option(item.name, JSON.stringify({id: item.id, column: item.name, type: 'relationship type', attr: item}));
                    optionsArr.push(option);
                    relationshipGroup.append(option);
                }
            });

            let containsTags = rowData.find( function( row ) {
                return row.rowObj.type === 'tags';
            });

            if (!containsTags) {
                tagOption = new Option('Tags', JSON.stringify({id: null, column: 'Tags', type: 'tags', attr: {id: null, name: 'Tags'}}));
                optionsArr.push(tagOption);
            }

            if (optionsArr.length === 0) {
                params.api.updateRowData({ remove: [rowData[rowData.length -1]] });
                params.api.refreshCells({ force: true });
                toastr.warning("All columns are assigned to this data view");
            } else {
                // selectValue is used when the user do not select a value from the drop-down
                this.selectValue = optionsArr[0];
                this.eInput = document.createElement('select');
                this.eInput.id = 'grid-drop-down';
                this.eInput.style.width = "100%";
                Utils.$(this.eInput).append(attributesGroup);
                Utils.$(this.eInput).append(relationshipGroup);
                Utils.$(this.eInput).append(tagOption);
            }

        } else {
            this.eInput = document.createElement('div');
        }
    };

    AgSelect.prototype.isKeyPressedNavigation = function (event) {
        return event.keyCode === 39 || event.keyCode === 37;
    };

    AgSelect.prototype.getGui = function () {
        return this.eInput;
    };

    AgSelect.prototype.afterGuiAttached = function () {
        if (this.params.data.isNew) {
            Utils.$(this.eInput).select2().val(this.params.value).trigger("change");
            Utils.$(this.eInput).select2({width: this.params.eGridCell.offsetWidth});
            this.eInput.focus();
            Utils.$(this.eInput).select2('open');
        } else {
            Utils.$(this.eInput).text = this.params.value.name;
        }
    };

    AgSelect.prototype.isCancelBeforeStart = function () {
        return false
    };

    AgSelect.prototype.isCancelAfterEnd = function () {
        return false
    };

    AgSelect.prototype.getValue = function () {
        if (Utils.$(this.eInput).val()) {
            return JSON.parse(Utils.$(this.eInput).val());
        }
        if (this.defaultValue.id === 0) {
           return JSON.parse(this.selectValue.value);
        }
        return this.defaultValue;
    };

    AgSelect.prototype.destroy = function () {
        if (this.eInput) {
            this.eInput.remove();
        }
        Utils.$(this.eInput).select2('close');
    };

    AgSelect.prototype.isPopup = function () {
        try {
            return AgSelect.prototype.cellEditorparams.isPopup
        } catch (e) {
            return false;
        }
    };

    return AgSelect
}




// WEBPACK FOOTER //
// ./app/components/bo-core/grids/DataViewColumnsAgGrid/components/GridSelect.tsx